import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  Paper,
  TableRow,
  TableCell,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "../../cssfiles/homepage.css";
import CustomLabel from "../CommonComponents/CustomLabel";
import {
  getDashboardGroupsReports,
  getDashboardsReports,
  getdashboardtemplatedetails,
  getdashboarlist,
  getEntireTemplateTree,
  linkDashboardtoTemplate,
  unlinkDashboardtoTemplate,
} from "../../Restclient/datacollection";
import CustomDropDown from "../CommonComponents/CustomDropDown";
import CustomButton from "../CommonComponents/CustomButton";
import { useSelector } from "react-redux";
import CustomCancelButton from "../CommonComponents/CustomCancelButton";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomTreeSelect from "../CommonComponents/CustomTreeSelect";

export default function TemplateConfigurator() {
  const projectId = useSelector(
    (state) => state.mainpagedata.selectedprojectname,
  );
  const logindetails = useSelector((state) => state.logindata.userdetails);
  const username = useSelector((state) => state.logindata.username);

  const [update, setUpdate] = useState(-1);

  const [table_rows, setTable_rows] = useState([]);
  const restcallbacktable = (res) => {
    setTable_rows(res.data);
  };
  useEffect(() => {
    getdashboarlist(
      logindetails.Organizationid,
      projectId,
      "All",
      restcallbackdashboard,
    );
    getdashboardtemplatedetails(restcallbacktable);
    getEntireTemplateTree(restCallbackTemplateTree);
    getDashboardGroupsReports((res) => {
      setDashboardGroupList(res.data.groups);
      setDashboardGroupIDList(res.data.ids);
    });
  }, [projectId, update]);

  const [selectedGroup, setSelectedGroup] = useState("");
  const handleChange = (value) => {
    setSelectedGroup(value);
  };

  const [templateList, setTemplateList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const handleTemplateChange = (value) => {
    setSelectedTemplate(value);
  };

  const [dashboardList, setDashboardList] = useState([]);
  const [dashboardIDList, setDashboardIDList] = useState([]);
  const [dashbaord, setDashboard] = useState("");
  const [dashboardPro, setDashboardPro] = useState("");
  const [groupid, setGroupid] = useState("");
  const restcallbackdashboard = (res) => {
    var dashboardli = [],
      dashboardProLi = [],
      groupidLi = [];
    for (let i = 0; i < res.dashboardlist.length; i++) {
      dashboardli.push(res.dashboardlist[i].Dashboardname);
      dashboardProLi.push(res.dashboardlist[i].dashboard_pro);
      groupidLi.push(res.dashboardlist[i].groupid);
    }
    setDashboardList(dashboardli);
    setDashboardPro(dashboardProLi);
    setGroupid(groupidLi);
  };

  const [selectedDashboard, setSelectedDashboard] = useState([]);

  const handleDashboardChange = (value) => {
    setSelectedDashboard(value);
  };

  const restlinkcallback = (res) => {
    setUpdate(res.data);
  };
  useEffect(() => {
    if (update === 1) {
      getdashboardtemplatedetails(restcallbacktable);
    }
    const timer = setTimeout(() => {
      setUpdate(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [update]);

  const handleClick = () => {
    if (!selectedTemplateVal || !dashboardGroup || !selectedDashboard) {
      setUpdate(3);
      return;
    }
    linkDashboardtoTemplate(
      selectedTemplateVal,
      dashboardGroupIDList[dashboardGroupList.indexOf(dashboardGroup)],
      dashboardIDList[dashboardList.indexOf(selectedDashboard)],
      username,
      restlinkcallback,
    );
  };

  const [updateUnlink, setUpdateUnlink] = useState(-1);
  const restunlinkcallback = (res) => {
    setUpdateUnlink(res.data);
  };
  useEffect(() => {
    if (updateUnlink === 1) {
      getdashboardtemplatedetails(restcallbacktable);
    }
    const timer = setTimeout(() => {
      setUpdateUnlink(-1);
    }, 3000);
    return () => clearTimeout(timer);
  }, [updateUnlink]);
  const handleUnlink = () => {
    if (!selectedTemplateVal || !dashboardGroup || !selectedDashboard) {
      setUpdateUnlink(3);
      return;
    }
    unlinkDashboardtoTemplate(
      selectedTemplateVal,
      dashboardGroupIDList[dashboardGroupList.indexOf(dashboardGroup)],
      dashboardIDList[dashboardList.indexOf(selectedDashboard)],
      username,
      restunlinkcallback,
    );
  };

  const [selectedTemplateVal, setSelectedTemplateVal] = useState("");
  const [templateTree, setTemplateTree] = useState([]);
  const restCallbackTemplateTree = (res) => {
    setTemplateTree(res.data);
  };

  const [dashboardGroupList, setDashboardGroupList] = useState([]);
  const [dashboardGroupIDList, setDashboardGroupIDList] = useState([]);
  const [dashboardGroup, setDashboardGroup] = useState("");

  useEffect(() => {
    getDashboardsReports(
      dashboardGroupIDList[dashboardGroupList.indexOf(dashboardGroup)],
      (res) => {
        setDashboardList(res.data.dashboards);
        setDashboardIDList(res.data.ids);
      },
    );
  }, [dashboardGroup]);

  const table_head = ["Dashboard Group", "Dashboard", "Template", "Operation"];

  const handleDelink = (row) => {
    getDashboardsReports(
      dashboardGroupIDList[dashboardGroupList.indexOf(row[0])],
      (res) => {
        unlinkDashboardtoTemplate(
          row[3],
          dashboardGroupIDList[dashboardGroupList.indexOf(row[0])],
          res.data.ids[res.data.dashboards.indexOf(row[1])],
          username,
          restunlinkcallback,
        );
      },
    );
  };

  return (
    <div
      style={{ height: "100%", boxSizing: "border-box" }}
      className="compliance-config"
    >
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          gap: "8px",
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row-reverse",
            alignItems: "right",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomButton buttonText={"Link"} onClick={handleClick} />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            <CustomButton buttonText={"Delink"} onClick={handleUnlink} />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
            }}
          >
            {update === 1 ? (
              <CustomLabel labelText={"Update Successfull!"} color={"green"} />
            ) : update === 0 ? (
              <CustomLabel labelText={"Update Unsuccessfull!"} color={"red"} />
            ) : update === 2 ? (
              <CustomLabel labelText={"Already Linked!"} />
            ) : update === 3 ? (
              <CustomLabel
                labelText={"Select all the required fields!"}
                color={"red"}
              />
            ) : (
              <></>
            )}
            {updateUnlink === 1 ? (
              <CustomLabel labelText={"Update Successfull!"} color={"green"} />
            ) : updateUnlink === 0 ? (
              <CustomLabel labelText={"Update Unsuccessfull!"} color={"red"} />
            ) : updateUnlink === 2 ? (
              <CustomLabel labelText={"Already Unlinked!"} />
            ) : updateUnlink === 3 ? (
              <CustomLabel
                labelText={"Select all the required fields!"}
                color={"red"}
              />
            ) : (
              <></>
            )}
          </Box>
        </Box>

        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "left",
            gap: "8px",
            padding: "8px",
            backgroundColor: "var(--PrimaryBackground)",
            boxSizing: "border-box",
            overflow: "auto",
          }}
        >
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <table
              width="100%"
              style={{
                textAlign: "left",
                padding: "0px",
                margin: "0px",
                boxSizing: "border-box",
              }}
            >
              <tr>
                <td style={{ width: "25%", paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Template*"}
                    htmlFor={"template"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomTreeSelect
                    options={templateTree}
                    value={selectedTemplateVal}
                    defaultValue={selectedTemplateVal}
                    onChange={(val) => setSelectedTemplateVal(val)}
                    disabledItemValues={(item) =>
                      item.type === "group" ||
                      (item.type === "template" &&
                        (item.dynamic === true ||
                          item.designer === "Custom")) ||
                      item.title?.startsWith("sg-") ||
                      item.value?.startsWith("sg-")
                    }
                    placeholder=""
                    width="227px"
                    fontSize="16px"
                  />
                </td>
              </tr>
              <tr>
                <td style={{ width: "25%", paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Dashboard Group*"}
                    htmlFor={"dashboard-group"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={dashboardGroupList}
                    onChange={(val) => setDashboardGroup(val)}
                    width={227}
                    name={"dashboard-group"}
                  />
                </td>
              </tr>
              <tr>
                <td style={{ width: "25%", paddingBottom: "36px" }}>
                  <CustomLabel
                    labelText={"Dashboard*"}
                    htmlFor={"dashboard-list"}
                    color={"var(--SecondaryText)"}
                    paddingTop={6}
                  />
                </td>
                <td style={{ paddingBottom: "36px" }}>
                  <CustomDropDown
                    options={dashboardList}
                    onChange={(val) => setSelectedDashboard(val)}
                    width={227}
                    name={"generate-list"}
                  />
                </td>
              </tr>
            </table>
          </Box>
          <Box
            sx={{
              width: "50%",
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              gap: "32px",
              padding: "8px",
              backgroundColor: "var(--SecondaryBackground)",
              boxSizing: "border-box",
              overflow: "auto",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "27px",
                }}
              >
                <TableContainer
                  component={Paper}
                  sx={{
                    width: "780px",
                    height: "499px",
                    paddingLeft: "0px",
                    backgroundColor: "var(--secondary-backgroundLK)",
                    paddingRight: "0px",
                  }}
                  elevation={0}
                >
                  <Table stickyHeader sx={{ width: "100%" }} size="small">
                    <TableHead>
                      <TableRow sx={{ border: "0px" }}>
                        {table_head.map((table_head_value, index) => (
                          <TableCell
                            key={index}
                            sx={{
                              textAlign: "left",
                              fontSize: "12px",
                              fontWeight: 700,
                              color: "var(--grey-variation-tableLK)",
                              backgroundColor: "var(--secondary-backgroundLK)",
                            }}
                          >
                            {table_head_value}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {table_rows.map((row, rowIndex) => (
                        <TableRow
                          key={rowIndex}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                            height: "9px",
                            "& > *": {
                              borderBottom:
                                "1px solid var(--table-boarder-line)",
                            },
                          }}
                        >
                          {row.map((cell, cellIndex) => {
                            if (cellIndex < 3) {
                              return (
                                <TableCell
                                  key={cellIndex}
                                  component="th"
                                  scope="row"
                                  sx={{
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    color: "var(--grey-variation-tablerowsLK)",
                                  }}
                                >
                                  {cell}
                                </TableCell>
                              );
                            }
                            return null;
                          })}
                          <TableCell
                            component="th"
                            scope="row"
                            sx={{
                              fontSize: "12px",
                              fontWeight: 400,
                              color: "var(--grey-variation-tablerowsLK)",
                            }}
                          >
                            <CustomActionButton
                              buttonText={"Delink"}
                              onClick={() => handleDelink(table_rows[rowIndex])}
                            />
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
